import axiosInstance from "../../interceptor/intercetptor-inctence"


export const getTransferAPI = (data) => {
	return axiosInstance.post(`pharma/get-transfer-details`, data);
}